export enum DataTypeLevel {
  Group = 'Group',
  EntityLevel = 'Entity_Level',
}
